module.exports = __webpack_public_path__ + "img/data_cs.2757c455.png";